import request from '@/router/axios';

// 招商审核 审核详情 taskId仅待审核需要传
export const getAuditDetail = (data) => {
  return request({
    url: '/api/blade-loanInvestmentInfo/loanInvestmentInfo/audit-detail',
    method: 'post',
    data: {
      id: data.id,
      taskId: data.taskId,
      type: data.type
    }
  })
}

// 招商 审核
export const groupAuditCost = (operatorType,data) => {
  return request({
    url: `/api/blade-loanInvestmentInfo/loanInvestmentInfo/group_audit_cost/${operatorType}`,
    method: 'post',
    data: {
      ...data
    }
  })
}

// 通用审核(包含 待法务审核 、 待负责人复核 、 待代理商付款 、待财务收款、待邮寄GPS、待确认GPS (邮寄gps))
export const generalAudit = (operatorType,data) => {
  return request({
    url: `/api/blade-loanInvestmentInfo/loanInvestmentInfo/audit/${operatorType}`,
    method: 'post',
    data: {
      ...data
    }
  })
}

// 生成大数据
export const investmentInfoBigData = (data) => {
  return request({
    url: `/api/blade-bigdataPdfGeneratorRecord/bigdataPdfGeneratorRecord/investmentInfoBigData`,
    method: 'post',
    data: {
      ...data
    }
  })
}

// 获取招商审核时间线
export const getTimeLineList = (id) => {
  return request({
    url: `/api/blade-loanInvestmentAuditRecord/loanInvestmentAuditRecord/timeline-list/${id}`,
    method: 'get'
  })
}